import styled from 'styled-components';

export const FilterStatusSpan = styled.span``;
